'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('../../../node_modules/react/jsx-runtime.js');
var React = require('react');

const MtCaptcha = (props) => {
    React.useEffect(() => {
        // @ts-ignore
        window.mtcaptchaConfig = {
            'sitekey': props.siteKey,
            'lang': props.language,
            'loadAnimation': 'false' //recommended for enable-low-friction-invisible-captcha setting
        };
        if (props.onVerified) {
            // @ts-ignore
            window.onVerifiedMtCaptcha = () => {
                props.onVerified && props.onVerified();
            };
            // @ts-ignore
            window.mtcaptchaConfig['verified-callback'] = 'onVerifiedMtCaptcha';
        }
        const mtServiceScriptElement = document.createElement('script');
        mtServiceScriptElement.src = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
        mtServiceScriptElement.async = true;
        document.head.appendChild(mtServiceScriptElement);
        const mtService2ScriptElement = document.createElement('script');
        mtService2ScriptElement.src = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
        mtService2ScriptElement.async = true;
        document.head.appendChild(mtService2ScriptElement);
    });
    return jsxRuntime.jsxRuntimeExports.jsx("div", { "data-testid": "mtcaptcha", children: jsxRuntime.jsxRuntimeExports.jsx("div", { className: "mtcaptcha" }) });
};

exports.default = MtCaptcha;
//# sourceMappingURL=MtCaptcha.js.map
